import React from 'react'
import { Row, Col } from 'antd';
import store from '@/store'
import { connect } from 'react-redux'
import { updateCategoryId } from '@/store/actions'

@connect(
  state => ({
    curCategoryId: state.curCategoryId,
    categories: state.categories
  }),
  { updateCategoryId }
)
class CategoryComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      marginTop: 0
    }
  }

  fetchList = (id) => {
    this.props.updateCategoryId(id)
  }

  handleScroll = (event) => {
    // 滚动条高度
    const clientHeight = document.documentElement.clientHeight; // 可视区域高度
    const scrollTop = document.documentElement.scrollTop;  // 滚动条滚动高度

    if (scrollTop > (240 + 24)) {
      this.setState({ marginTop: scrollTop - (240 + 24) })
    }
  }

  async componentDidMount () {
    // window.addEventListener('scroll', this.handleScroll);
  }

  render () {
    const { fetchList } = this
    const { categories } = this.props
    const { marginTop } = this.state

    return (
      <Row gutter={18} style={{ marginTop }}>
        <Col span={24}>
          <div className="category-container">
            <div className="category-wrapper">
              <div className="title">分类</div>
              <ul className="category-items">
                {
                  categories.map(item => (
                    <li key={item.id} className="category-item" onClick={() => fetchList(item.id)}>
                      <span>
                        {item.title}
                      </span>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    )
  }
}
export default CategoryComponent